import 'reflect-metadata';
import { Relation } from '../core/decorators/relation.decorator';
import { ModuleEntity } from '../module/module.entity';
import { BaseEntity } from '../core/entities/base.entity';
import { RelationRef } from '../core/types/entity-types';
import { LearningSectionEntity } from '../learning-section/learning-section-entity';
import { ConsumerData } from '../core/types';
import { ConsumerEntity } from '../consumer/consumer.entity';

export class LearningUnitEntity extends BaseEntity {
  title!: string;
  status!: string;

  subtitle?: string;
  preview?: string[];
  description?: string;
  didactic_hint?: string;
  lesson_section?: string;
  processing_time?: number;
  federal_state?: string[];
  learning_unit_goal?: string;
  learning_unit_type?: string;
  changed_by?: string;
  version?: number;
  consumerData?: ConsumerData;
  moduleIds?: string[];

  @Relation()
  consumer?: RelationRef<ConsumerEntity>[];

  @Relation()
  modules?: RelationRef<ModuleEntity>[];

  @Relation()
  learningSections?: RelationRef<LearningSectionEntity>[];
}
